"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const analyticsUtils_1 = require("../../utils/analyticsUtils");
const testUtils_1 = require("../../utils/testUtils");
const styles = require('./Link.module.scss');
const Link = (_a, ref) => {
    var { children, className = '', color = 'blue', noDecoration, noUnderline, rel, trackingAttributes, typeIdOptions, target } = _a, rest = __rest(_a, ["children", "className", "color", "noDecoration", "noUnderline", "rel", "trackingAttributes", "typeIdOptions", "target"]);
    return (react_1.default.createElement("a", Object.assign({ ref: ref, className: (0, classnames_1.default)(styles.root, {
            [styles.blue]: color === 'blue',
            [styles.grey]: color === 'grey',
            [styles.yellow]: color === 'yellow',
            [styles.white]: color === 'white',
            [styles.black]: color === 'black',
            [styles.lightGrey]: color === 'light-grey',
            [styles.noUnderline]: noUnderline,
            [styles.noDecoration]: noDecoration,
            [className]: !!className,
        }) }, (0, analyticsUtils_1.getTrackingAttributes)(trackingAttributes), (0, testUtils_1.getDataTypeAttribute)(typeIdOptions), rest, { target: target }, ((rel || target === '_blank') && {
        rel: `${rel !== null && rel !== void 0 ? rel : ''}${target === '_blank' ? ' noopener noreferrer' : ''}`,
    })), children));
};
exports.default = (0, react_1.forwardRef)(Link);
//# sourceMappingURL=Link.js.map